var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppDrop',{on:{"drop":_vm.moveTaskOrColumn}},[_c('AppDrag',{staticClass:"task",attrs:{"transferData":{
    type: 'task',
    fromColumnIndex: _vm.columnIndex,
    fromTaskIndex: _vm.taskIndex
}}},[_c('div',{on:{"click":function($event){return _vm.goToTask(_vm.task)}}},[_c('span',{staticClass:"w-full flex-no-shrink font-bold"},[_vm._v(_vm._s(_vm.task.name))]),(_vm.task.description)?_c('p',{staticClass:"w-full flex-no-shrink mt-1 text-sm"},[_vm._v(_vm._s(_vm.task.description))]):_vm._e()])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }